import { useState } from "react";
import Input from "./Input";
import Output from "./Output";

function Tool() {
    const [canvasList, setCanvasList] = useState([]);
    function addCanvas(canvas) {
        setCanvasList([canvas, ...canvasList]);
    }
    function removeCanvas(index) {
        setCanvasList([
            ...canvasList.slice(0, index),
            ...canvasList.slice(index + 1),
        ]);
    }
    return (
        <div className="container">
            <Input updateMur={addCanvas} />
            <Output canvasList={canvasList} removeCarte={removeCanvas} />
        </div>
    );
}

export default Tool;
